import { Link } from "react-router-dom";

const apps = [
  {
    name: "Touhack",
    icon: "@",
    platform: "iOS / Android",
    desc: "A Japanese Nethack clone. Descend the dungeon, one tile at a time.",
    status: "released",
  },
  {
    name: "cjk-etc",
    icon: "漢",
    platform: "iOS / Android",
    desc: "A kanji etymology explorer. Trace characters back to their roots and see how they came to be.",
    status: "released",
  },
  {
    name: "Reverse Snake",
    icon: "~~~o",
    platform: "iOS / Android",
    desc: "A retake on the classic game of Snake. You know the game — now play it the other way around.",
    status: "released",
  },
];

export default function Apps() {
  return (
    <div data-testid="apps-page" className="max-w-xl mx-auto px-6 py-12">
      <header>
        <h1 className="font-bold text-3xl">Our apps</h1>
        <p className="font-mono90 text-sm mt-2">
          [ <Link data-testid="nav-home-link" to="/">back to homepage</Link> ]
        </p>
      </header>

      <hr className="hr90" />

      <section data-testid="apps-list">
        <p className="text-lg leading-relaxed mb-6">
          Apps we thought should exist, so we made them.
        </p>
        {apps.map((app) => (
          <div key={app.name} data-testid={`app-item-${app.name.toLowerCase()}`} className="mb-6">
            <h2 className="font-bold text-xl">
              <span className="font-mono90" aria-hidden="true">[{app.icon}]</span> {app.name}{" "}
              <span className="font-mono90 text-xs font-normal">
                ({app.platform}) {app.status === "in development" && "— coming soon"}
              </span>
            </h2>
            <p className="text-lg leading-relaxed mt-1">{app.desc}</p>
          </div>
        ))}
        <p className="font-mono90 text-sm">
          Want to try one? <a data-testid="apps-contact-link" href="/#contact">Write to us</a> and we'll send you a link.
        </p>
      </section>

      <hr className="hr90" />

      <footer className="font-mono90 text-xs">
        <p>&copy; 2026 WanCo Industries</p>
      </footer>
    </div>
  );
}
